import React, { useEffect, useState } from "react";
import {
    Box,
    Grid2,
    Card,
    CardContent,
    Typography,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    TextField,
    FormLabel,
} from "@mui/material";
import Chart from "react-apexcharts";
import { fetchLeads } from "../../redux/Slice/LeadSlice";
import { useDispatch, useSelector } from "react-redux";
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const LeadAnalytics = () => {
    const { leads } = useSelector((state) => state.leads);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchLeads());
    }, [dispatch]);

    const pieChartOptions = {
        chart: {
            type: "donut",
            animations: {
                enabled: true,
                easing: "easeinout",
                speed: 800,
            },
        },
        labels: ["Hot", "Warm", "Cold"],
        // colors: ["#FF6384", "#36A2EB", "#FFCE56"],
        legend: {
            position: "bottom",
            labels: {
                colors: "#333",
                useSeriesColors: false,
            },
        },
        dataLabels: {
            enabled: true,
            style: {
                colors: ["#000"],
            },
            formatter: (val) => `${val.toFixed(1)}%`,
        },
        tooltip: {
            theme: "dark",
        },
        plotOptions: {
            pie: {
                donut: {
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            label: "Total",
                            fontSize: "16px",
                        },
                    },
                },
            },
        },
    };
    const pieChartData = [30, 40, 30];

    const barChartOptions = {
        chart: {
            type: "bar",
            animations: {
                enabled: true,
                easing: "easeinout",
                speed: 1200,
            },
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                horizontal: false,
                columnWidth: "50%",
                colors: {
                    ranges: [
                        { from: 0, to: 20, color: "#36A2EB" },
                        { from: 21, to: 40, color: "#FF6384" },
                    ],
                },
            },
        },
        xaxis: {
            categories: ["New", "Assigned", "Converted", "Lost"],
        },
        // colors: ["#36A2EB", "#FF6384", "#4BC0C0", "#FF6384"],
        tooltip: {
            theme: "dark",
        },
    };
    const barChartData = [
        {
            name: "Status Breakdown",
            data: [40, 25, 20, 15],
        },
    ];

    const lineChartOptions = {
        chart: {
            type: "line",
            animations: {
                enabled: true,
                easing: "easeinout",
                speed: 1000,
            },
        },
        xaxis: {
            categories: ["Week 1", "Week 2", "Week 3", "Week 4"],
        },
        stroke: {
            curve: "smooth",
            colors: ["#36A2EB"],
        },
        markers: {
            size: 6,
            colors: ["#FFFFFF"],
            strokeColors: "#36A2EB",
            strokeWidth: 3,
            hover: {
                size: 10,
                sizeOffset: 3,
            },
        },
        tooltip: {
            theme: "dark",
        },
    };
    const lineChartData = [
        {
            name: "Follow-up Trends",
            data: [10, 15, 12, 18],
        },
    ];

    const [filters, setFilters] = useState({
        dateRange: "",
        employee: "",
        status: "",
        enquiryType: "",
    });

    const convertedLeadsCount = leads.filter(
        (lead) => lead.leadStatus === "Convert to Customer"
    ).length;

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
    };

    return (
        <Box sx={{ padding: 3, minHeight: "100vh" }}>
            {/* Page Title */}
            <Typography variant="h4" gutterBottom>
                Lead Analytics
            </Typography>

            {/* Filters */}
            <Grid2 container spacing={2} sx={{ marginBottom: 3 }}>
                {/* Date Range Filter */}
                <Grid2 item size={6}>
                    <FormControl fullWidth>
                        <FormLabel>Date Range *</FormLabel>
                        <TextField
                            type="date"
                            name="dateRange"
                            InputLabelProps={{ shrink: true }}
                            value={filters.dateRange}
                            onChange={handleFilterChange}
                        />
                    </FormControl>
                </Grid2>
                {/* <Grid2 item size={6}>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
        <FormControl fullWidth>
            <FormLabel>Date Range *</FormLabel>
            <MobileDateTimePicker
                value={filters.dateRange ? dayjs(filters.dateRange) : null} // Use your state value
                onChange={(newValue) => {
                    if (newValue && newValue.isValid()) {
                        handleFilterChange({
                            target: { name: 'dateRange', value: newValue.format('YYYY-MM-DD') } // Use only the date part
                        });
                    } else {
                        handleFilterChange({
                            target: { name: 'dateRange', value: null }
                        });
                    }
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        fullWidth
                    />
                )}
                views={['day']} // Restrict the picker to show only the date (no time selection)
                mask="____-__-__" // Optional: Add a mask for the input to show YYYY-MM-DD format
            />
        </FormControl>
    </LocalizationProvider>
</Grid2> */}




                {/* Employee Filter */}
                <Grid2 item size={6}>
                    <FormControl fullWidth>
                        <FormLabel>Employee</FormLabel>
                        <Select
                            name="employee"
                            value={filters.employee}
                            onChange={handleFilterChange}
                            displayEmpty
                        >
                            <MenuItem value="" disabled>Employee (Select)</MenuItem>
                            <MenuItem value="Employee1">Employee 1</MenuItem>
                            <MenuItem value="Employee2">Employee 2</MenuItem>
                        </Select>
                    </FormControl>
                </Grid2>

                {/* Status Filter */}
                <Grid2 item size={6}>
                    <FormControl fullWidth>
                        <FormLabel>Status</FormLabel>
                        <Select
                            name="status"
                            value={filters.status}
                            onChange={handleFilterChange}
                            displayEmpty
                        >
                            <MenuItem value="" disabled>Status (Select)</MenuItem>
                            <MenuItem value="New">New</MenuItem>
                            <MenuItem value="Assigned">Assigned</MenuItem>
                            <MenuItem value="Converted">Converted</MenuItem>
                            <MenuItem value="Lost">Lost</MenuItem>
                        </Select>
                    </FormControl>
                </Grid2>

                {/* Enquiry Type Filter */}
                <Grid2 item size={6}>
                    <FormControl fullWidth>
                        <FormLabel>Enquiry Type</FormLabel>
                        <Select
                            name="enquiryType"
                            value={filters.enquiryType}
                            onChange={handleFilterChange}
                            displayEmpty
                        >
                            <MenuItem value="" disabled>Enquiry Type (Select)</MenuItem>
                            <MenuItem value="Hot">Hot</MenuItem>
                            <MenuItem value="Warm">Warm</MenuItem>
                            <MenuItem value="Cold">Cold</MenuItem>
                        </Select>
                    </FormControl>
                </Grid2>
            </Grid2>

            {/* Summary Cards */}
            <Grid2 container spacing={3}>
                {[
                    { title: "Total Leads", value: leads?.length,color: "#36A2EB" },
                    { title: "Converted Leads", value: convertedLeadsCount, color: "#4BC0C0" },
                    { title: "Lost Leads", value: 15 , color: "#FF6384"},
                    { title: "Pending Follow-ups", value: 65, color: "#FFCE56" },
                ].map((card, index) => (
                    <Grid2 item size={6} key={index}>
                        <Card sx={{ backgroundColor: "#fff" }}>
                            <CardContent>
                                <Typography variant="h6">{card.title}</Typography>
                                <Typography variant="h4" sx={{ color: card.color }}>{card.value}</Typography>
                            </CardContent>
                        </Card>
                    </Grid2>
                ))}
            </Grid2>

            {/* Charts */}
            <Grid2 container spacing={3} sx={{ marginTop: 3 }}>
                <Grid2 item size={4}>
                    <Card sx={{ backgroundColor: "#fff" }}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Distribution of Enquiry Types
                            </Typography>
                            <Chart options={pieChartOptions} series={pieChartData} type="donut" height={317} />
                        </CardContent>
                    </Card>
                </Grid2>
                <Grid2 item size={4}>
                    <Card sx={{ backgroundColor: "#fff" }}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Status Breakdown
                            </Typography>
                            <Chart options={barChartOptions} series={barChartData} type="bar" height={300} />
                        </CardContent>
                    </Card>
                </Grid2>
                <Grid2 item size={4}>
                    <Card sx={{ backgroundColor: "#fff" }}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Follow-up Trends Over Time
                            </Typography>
                            <Chart options={lineChartOptions} series={lineChartData} type="line" height={300} />
                        </CardContent>
                    </Card>
                </Grid2>
            </Grid2>
        </Box>
    );
};

export default LeadAnalytics;
